export default __webpack_public_path__ + "static/media/mf.77907fec.jpg";